var map = {
	"./BudgetInfoLabel": [
		3985,
		366
	],
	"./BudgetInfoLabel.js": [
		3985,
		366
	],
	"./StaffListLabel": [
		3171,
		171
	],
	"./StaffListLabel.js": [
		3171,
		171
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1949;
module.exports = webpackAsyncContext;